/*******************************************************
OPEN TEAM PREVIEW MODAL
Used on the bracketology page for CBB.
********************************************************/

import buildModal from '../../universal/modal-window/build-modal';
import showErrorNotificationBar from '../../universal/error-handling/show-error-notification-bar';

function imageExists(image_url){

    var http = new XMLHttpRequest();

    http.open('HEAD', image_url, false);
    http.send();

    return http.status != 404;

}

export default async function openTeamPreview(event) {
    const $button = $(event.currentTarget);
    const {team, secondteam } = $button.data();

    const teamName = team;
    const secondTeamName = secondteam;

    const teamLogo = team.replace(" ", "-");
    const secondTeamLogo = secondteam.replace(" ", "-");

    try {
        const response = await $.ajax({
            type   : 'GET',
            url    : `/cbasketball/ajax/get-team-preview.php`,
            data   : {
                team: teamName,
                secondteam: secondTeamName,
            },
            timeout: 8000,
        });

        const { previewHTML, success } = response;

        // Set the table loading message
        const loadingMessage = `Loading ${teamName} Preview`;

        let modalTitle = "";

        // Build the title
        if ( secondteam == "" || secondteam == undefined || secondteam == null ) {
            if (imageExists(`/images/teamlogo/cbasketball/${teamLogo}.png`)) {
                modalTitle = `
                <div>
                    <img style="width:35px;margin-right:7px;" src="https://content.rotowire.com/images/teamlogo/cbasketball/${teamLogo}.png"> ${teamName}</span>
                </div>`;
            } else {
                modalTitle = `
                <div>
                    ${teamName}</span>
                </div>`;
            }
        } else {
            if (imageExists(`/images/teamlogo/cbasketball/${teamLogo}.png`)) {
                modalTitle = `
                <div>
                    <img style="width:35px;margin-right:7px;" src="https://content.rotowire.com/images/teamlogo/cbasketball/${teamLogo}.png"> ${teamName} / ${secondTeamName}</span>
                </div>`;
            } else {
                modalTitle = `
                <div>
                    ${teamName} / ${secondTeamName}</span>
                </div>`;
            }
        }

        // Build the content of the modal
        const modalContent = `
            <div style="padding: 15px;">
                ${previewHTML}
            </div>`;

        // Get the modal window HTML
        const modalHTML = buildModal({
            fullWidth: false,
            title    : modalTitle,
            content  : modalContent,
        });

        // Append the modal window to the page
        $('.page').append(modalHTML);
    }
    catch (error) {
        showErrorNotificationBar(error.message || 'We were unable to retrieve updates for you. Please try again.', 3000);
    }

}
